import request from "../utils/request.js";

export function getApiDocumentList(params) {
  return request({
    url: '/api-documents/list',
    method: 'GET',
    params,
  });
}

export function getApiDocumentDetail(id) {
  return request({
    url: `/api-documents/${id}`,
    method: 'GET',
  });
}

export function createApiDocument(data) {
  return request({
    url: '/api-documents',
    method: 'POST',
    data,
  });
}

export function updateApiDocument(data) {
  return request({
    url: '/api-documents',
    method: 'PUT',
    data,
  });
}

export function deleteApiDocument(id) {
  return request({
    url: `/api-documents/${id}`,
    method: 'DELETE',
  });
}

export function copyApiDocumentVersion(data) {
  return request({
    url: '/api-documents/copy-version',
    method: 'POST',
    data,
  });
}

export function getApiDocumentVersions() {
  return request({
    url: '/api-documents/versions',
    method: 'GET',
  });
}

export function getPublicApiDocumentVersions() {
  return request({
    url: '/api-documents/public/versions',
    method: 'GET',
  });
}

export function getPublicApiDocuments(version) {
  return request({
    url: '/api-documents/public/list',
    method: 'GET',
    params: { version },
  });
}

export function getApiDocumentAuthConfig(companyId) {
  return request({
    url: '/api-documents/auth/config',
    method: 'GET',
    params: companyId ? { companyId } : {},
  });
}

export function regenerateApiDocumentAuthConfig(companyId) {
  return request({
    url: '/api-documents/auth/config/regenerate',
    method: 'POST',
    params: companyId ? { companyId } : {},
  });
}
